










import { defineComponent } from '~/utils/nuxt3-migration'

export enum VideoType {
  YOUTUBE = 'youtube'
}

export default defineComponent({
  props: {
    videoId: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '360px'
    }
  },
  computed: {
    src() {
      switch (this.type) {
        case VideoType.YOUTUBE: {
          return `https://www.youtube.com/embed/${this.videoId}?origin=https://www.car.gr`
        }
        default: {
          return null
        }
      }
    }
  }
})
